(function () {
  const boundForms = new WeakSet();

  function toInt(v) {
    const n = parseInt(String(v ?? "").replace(/[^\d]/g, ""), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function init(root) {
    root = root || document;

    const boxes = root.querySelectorAll(".minqty-msg[data-minqty-msg]");
    if (!boxes.length) return;

    boxes.forEach((msgEl) => {
      const sectionId = msgEl.dataset.sectionId;
      if (!sectionId) return;

      const qtyInput =
        document.getElementById(`Quantity-${sectionId}`) ||
        msgEl.closest(`#Quantity-Form-${sectionId}`)?.querySelector(".quantity__input");

      const form =
        document.getElementById(`product-form-${sectionId}`) ||
        document.querySelector(`form#product-form-${sectionId}`);

      if (!qtyInput || !form) return;
      if (boundForms.has(form)) return;
      boundForms.add(form);

      const customMin = toInt(msgEl.dataset.minqty || "0");
      if (customMin <= 1) return;

      function getVariantMin() {
        return Math.max(1, toInt(qtyInput.getAttribute("min")) || toInt(qtyInput.dataset.min) || 1);
      }

      function getMin() {
        return Math.max(customMin, getVariantMin());
      }

      function renderMessage(qty, min) {
        const falta = Math.max(0, min - qty);
        if (falta <= 0) return "";
        return `
          <span>
            Quantidade mínima para compra: <strong>${min}</strong> unidades.
            Você selecionou <strong>${qty}</strong>. Faltam <strong>${falta}</strong>.
          </span>
          <button type="button" class="minqty-msg__btn" data-minqty-fix>Adicionar ${min}</button>
        `;
      }

      function showMsg(qty, min) {
        msgEl.innerHTML = renderMessage(qty, min);
        msgEl.hidden = false;

        msgEl.classList.add("is-visible");
        msgEl.classList.remove("is-shake");
        void msgEl.offsetWidth;
        msgEl.classList.add("is-shake");

        msgEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }

      function hideMsg() {
        msgEl.hidden = true;
        msgEl.classList.remove("is-visible", "is-shake");
        msgEl.innerHTML = "";
      }

      function validate(showIfInvalid) {
        const qty = Math.max(0, toInt(qtyInput.value));
        const min = getMin();

        if (qty < min) {
          if (showIfInvalid) showMsg(qty || 0, min);
          return false;
        }

        hideMsg();
        return true;
      }

      // Mostra o box quando tentar comprar/adicionar
      form.addEventListener(
        "submit",
        function (e) {
          if (!validate(true)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            qtyInput.focus({ preventScroll: true });
            return false;
          }
        },
        true
      );

      // Se estiver aberto, atualiza ao mudar qty
      function refreshIfVisible() {
        if (msgEl.hidden) return;
        validate(true);
      }
      qtyInput.addEventListener("input", refreshIfVisible);
      qtyInput.addEventListener("change", refreshIfVisible);

      // Botão "Usar X"
      msgEl.addEventListener("click", function (e) {
        const btn = e.target.closest("[data-minqty-fix]");
        if (!btn) return;

        const min = getMin();
        qtyInput.value = String(min);
        qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));

        hideMsg();
        qtyInput.focus({ preventScroll: true });
      });
    });
  }

  function boot() {
    init(document);

    // Re-init quando Dawn recria o HTML
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (
            node.matches?.(".minqty-msg[data-minqty-msg]") ||
            node.querySelector?.(".minqty-msg[data-minqty-msg]")
          ) {
            init(node);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", (e) => init(e.target));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
